import {
  AutomationActionStepId,
  AutomationCustomIOType,
  AutomationFeature,
  AutomationIOType,
  AutomationStepDefinition,
  AutomationStepType,
} from "@budibase/types"

export const definition: AutomationStepDefinition = {
  name: "Bash Scripting",
  tagline: "Execute a bash command",
  icon: "git-branch",
  description: "Run a bash script",
  type: AutomationStepType.ACTION,
  internal: true,
  features: {
    [AutomationFeature.LOOPING]: true,
  },
  stepId: AutomationActionStepId.EXECUTE_BASH,
  inputs: {},
  schema: {
    inputs: {
      properties: {
        code: {
          type: AutomationIOType.STRING,
          customType: AutomationCustomIOType.CODE,
          title: "Code",
        },
      },
      required: ["code"],
    },
    outputs: {
      properties: {
        stdout: {
          type: AutomationIOType.STRING,
          description: "Standard output of your bash command or script",
        },
        success: {
          type: AutomationIOType.BOOLEAN,
          description: "Whether the command was successful",
        },
      },
      required: ["stdout"],
    },
  },
}
